import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usersAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { parseApiError } from '../utils/errors';

export default function ChangePassword() {
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const forced = !!user?.must_change_password;
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.new_password !== form.confirm) { setError('New passwords do not match.'); return; }
    setSaving(true);
    try {
      await usersAPI.changePassword({ current_password: form.current_password, new_password: form.new_password });
      const { data } = await usersAPI.getMe();
      updateUser(data);
      if (data.role === 'super_admin') navigate('/admin/dashboard');
      else if (data.role === 'hr') navigate('/hr/dashboard');
      else navigate('/employee/dashboard');
    } catch (err) {
      setError(parseApiError(err, 'Failed to change password.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page" style={{ maxWidth: 480, margin: '40px auto' }}>
      <div className="page-header"><h2>Change Password</h2></div>
      {forced && (
        <div className="alert alert-info">
          For security, you must set a new password before continuing.
        </div>
      )}
      <form onSubmit={submit} className="form-card">
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="form-group">
          <label>Current Password *</label>
          <input type="password" required value={form.current_password} onChange={set('current_password')} autoComplete="current-password" />
        </div>
        <div className="form-group">
          <label>New Password *</label>
          <input type="password" required value={form.new_password} onChange={set('new_password')} autoComplete="new-password" />
          <small className="field-hint">Min 8 chars with uppercase, lowercase, number, and special character.</small>
        </div>
        <div className="form-group">
          <label>Confirm New Password *</label>
          <input type="password" required value={form.confirm} onChange={set('confirm')} autoComplete="new-password" />
        </div>
        <div className="form-actions">
          {!forced && <button type="button" className="btn btn-ghost" onClick={() => navigate(-1)}>Cancel</button>}
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Change Password'}</button>
        </div>
      </form>
    </div>
  );
}
